<template>
  <div class="table-settings-container">
    <el-dropdown
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
      >
        <i class="el-icon-more" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="openSettingsDialog">
          <i class="el-icon-setting" /> Táblázat beállítások
        </el-dropdown-item>
        <el-dropdown-item
          v-if="options.includes('export')"
          :command="openExportDialog"
        >
          <i class="el-icon-download" /> Exportálás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="options.includes('import')"
          :command="handleImportDialogVisibility"
        >
          <i class="el-icon-upload" /> Importálás
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <ImportDialog
      :is-dialog-visible="isImportDialogVisible"
      :store-module="storeModule"
      @visibilityChanged="handleImportDialogVisibility"
    />
    <el-dialog
      :title="type === 'settings' ? 'Táblázat beállításai' : 'Táblázat exportálás'"
      :visible.sync="dialogVisible"
      width="600px"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-row
          v-if="type === 'export'"
          :gutter="20"
        >
          <el-col :span="12">
            <el-form-item
              label="Fájl név"
            >
              <el-input v-model="fileName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Fájl formátum"
            >
              <el-select
                v-model="fileFormat"
                style="width: 100%;"
              >
                <el-option
                  label="XLSX"
                  value="Xlsx"
                >
                  XLSX
                </el-option>
                <el-option
                  label="XLS"
                  value="Xls"
                >
                  XLS
                </el-option>
                <el-option
                  label="CSV"
                  value="Csv"
                >
                  CSV
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20">
        <el-col :span="12">
          <h4>Oszlopok</h4>
          <draggable
            class="list-group"
            tag="ul"
            group="columns"
            :list="columns"
            v-bind="dragOptions"
            style="min-height: 100px;"
            @start="drag = true"
            @end="drag = false"
          >
            <transition-group
              type="transition"
              :name="!drag ? 'flip-list' : null"
              :class="'columns-list original-list' + (columns.length === 0 ? ' empty-list' : '')"
            >
              <li
                v-for="element in columns"
                :key="element.value"
                class="list-group-item"
              >
                <i
                  class="el-icon-rank"
                  aria-hidden="true"
                />
                {{ labels[element.value] }}
              </li>
            </transition-group>
          </draggable>
        </el-col>
        <el-col :span="12">
          <h4>Kiválasztott oszlopok</h4>
          <draggable
            class="list-group"
            tag="ul"
            group="columns"
            :list="selectedColumns"
            v-bind="dragOptions"
            :move="checkMove"
            @start="drag = true"
            @end="drag = false"
          >
            <transition-group
              type="transition"
              :name="!drag ? 'flip-list' : null"
              :class="'columns-list' + (selectedColumns.length === 0 ? ' empty-list' : '')"
            >
              <li
                v-for="element in selectedColumns"
                :key="element.value"
                :class="'list-group-item' + (element.fixed ? ' locked' : '')"
              >
                <i
                  class="el-icon-rank"
                  aria-hidden="true"
                />
                {{ labels[element.value] }}
                <el-tag
                  v-if="element.fixed"
                  size="mini"
                  type="warning"
                  style="float: right;"
                >
                  Kötelező oszlop
                </el-tag>
              </li>
            </transition-group>
          </draggable>
        </el-col>
      </el-row>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">
          Mégsem
        </el-button>
        <el-button
          v-if="type === 'settings'"
          type="primary"
          :loading="loading"
          @click="save"
        >
          Mentés
        </el-button>
        <el-button
          v-if="type === 'export'"
          type="primary"
          :loading="loading"
          @click="exportToExcel"
        >
          Exportálás
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import { saveAs } from 'file-saver';
import ImportDialog from './utils/TableSettingsDialogs/ImportDialog.vue';

export default {
  components: {
    draggable,
    ImportDialog,
  },
  props: ['config', 'allcolumns', 'labels', 'storeModule', 'options'],
  data() {
    return {
      type: '',
      drag: false,
      dialogVisible: false,
      columns: [],
      selectedColumns: [],
      dragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      },
      fileName: '',
      fileFormat: '',
      loading: false,
      isImportDialogVisible: false
    };
  },
  computed: {
      activeIndex() {
        return this.$route.path;
      },
      profileUrl() {
        if (this.user && this.user.email) {
          return gravatar.url(this.user.email);
        } else {
          return null;
        }
      },
    },
  watch: {
    config() {
      this.loadColumns();
    },
  },
  mounted() {
    this.loadColumns();
  },
  methods: {
    handleAction(action) {
      action();
    },
    loadColumns() {
      if (this.config) {
        this.columns = this.allcolumns.filter(c => !this.config.columns.find(cl => cl.value === c.value));
        this.selectedColumns = JSON.parse(JSON.stringify(this.config.columns));
      }
    },
    openSettingsDialog() {
      this.selectedColumns = this.config.columns;
      this.type = 'settings';
      this.dialogVisible = true;
    },

    openExportDialog() {
      this.selectedColumns = this.selectedColumns.map(sc => {
        return { value: sc.value };
      });
      this.type = 'export';
      this.dialogVisible = true;
    },

    checkMove(evt) {
      if (evt.draggedContext.element.fixed && evt.to.classList.contains('original-list')) {
        return false;
      }
    },
    async save() {
      this.loading = true;
      await axios.post('api/table-settings', {
        id: this.config.id,
        type: this.config.type,
        config: JSON.stringify({
          columns: this.selectedColumns,
          sort: this.config.sort
        }),
      });
      await this.$store.dispatch(this.storeModule + '/fetchTableConfig');
      this.loading = false;
      this.dialogVisible = false;
    },
    async exportToExcel() {
      this.loading = true;
      let lf = this.$store.getters[this.storeModule + '/filterString'];
      let urlParams = new URLSearchParams(lf);
      let urlParamsObject = Object.fromEntries(urlParams);
      const data = {
        searchParams: urlParamsObject,
        columns: this.selectedColumns.map(sc => sc.value),
        fileName: this.fileName,
        fileFormat: this.fileFormat
      };
      try {
        await this.$store.dispatch(this.storeModule + '/excelExport', {
          data,
          fileName: this.fileName,
          fileFormat: this.fileFormat
        });
        this.loadColumns();
      } catch (e) {
      }
      this.fileFormat = '';
      this.fileName = '';
      this.loading = false;
      this.dialogVisible = false;
    },
    handleImportDialogVisibility() {
      this.isImportDialogVisible = !this.isImportDialogVisible
    }

  },
};
</script>

<style lang="scss">
  .el-table th div {
    line-height: 1;
  }

  div.table-settings-container {
    padding: 0 !important;
    float: right;
    line-height: 1;

    .el-dropdown {
      padding-right: 0;
    }
  }

  .list-group {
    padding: 0;

    .columns-list {
      display: block;
      width: 100%;
      min-height: 100px;

      &.empty-list {
        border: 1px dashed #afafaf;
        border-radius: 3px;

        &::after {
          content: 'Húzd ide az eltávolítandó oszlopot';
          justify-content: center;
          display: flex;
          align-items: center;
          height: 100%;
          margin-top: 40px;
        }
      }
    }

    .list-group-item {
      list-style: none;
      padding: 13px;
      margin-bottom: -1px;
      border: 1px solid rgba(0, 0, 0, .125);
      cursor: move;
      background: #ffffff;
      line-height: 1.45;
      transition: 0.3s;

      &:hover {
        background: #F5F7FA;
        transition: 0.3s;
      }

      &:first-child {
        border-top-left-radius: .25rem;
        border-top-right-radius: .25rem;
      }

      &:last-child {
        border-bottom-right-radius: .25rem;
        border-bottom-left-radius: .25rem;
      }
    }
  }
</style>
